import type { accountTypes, statuses, verticalTypes } from "./types";
// Address Information Interface
export interface PrimaryAddress {
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

// Service Account Creation Request Interface
export interface ServiceAccountCreationRequest {
  dealerCode: null;
  companyName: string;
  program: null;
  programGroupType: null;
  status: statuses;
  type: accountTypes;
  verticalType: verticalTypes;
  franchiseNames: null;
  primaryAddress: PrimaryAddress;
  requestedServiceAccountId: null;
  email: string | null;
  workPhone: string | null;
}

// Audit Information Interface
export interface AccountAudit {
  created: string;
  createdBy: string;
  lastModified: string;
  lastModifiedBy: string;
}

// Service Account Creation Response Interface
export interface ServiceAccountCreationResponse {
  id: string;
}

// Form Validation Interface
export interface CreateAccountFormData {
  companyName: string;
  accountType: accountTypes;
  verticalType: verticalTypes;
  address1: string;
  address2?: string;
  city?: string;
  state?: string;
  country?: string;
  zipCode?: string;
}

// Form Validation Errors Interface
export interface CreateAccountFormErrors {
  companyName?: string;
  accountType?: string;
  verticalType?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  country?: string;
  zipCode?: string;
}

// Field Length Constants
export const COMPANY_NAME_MAX_LENGTH = 100;
export const ADDRESS_MAX_LENGTH = 100;
export const CITY_MAX_LENGTH = 100;
export const STATE_LENGTH = 2;
export const COUNTRY_LENGTH = 3;

export const ValidationConstraints = {
  CREATE_ACCOUNT: {
    COMPANY_NAME_REQUIRED: "Company Name is required",
    COMPANY_NAME_MAX_LENGTH: `Company Name must be ${COMPANY_NAME_MAX_LENGTH} characters or less`,
    ACCOUNT_TYPE_REQUIRED: "Account Type is required",
    VERTICAL_TYPE_REQUIRED: "Vertical Type is required",
    ADDRESS_REQUIRED: "Address is required",
    ADDRESS_MAX_LENGTH: `Address must be ${ADDRESS_MAX_LENGTH} characters or less`,
    CITY_REQUIRED: "City is required",
    CITY_MAX_LENGTH: `City must be ${CITY_MAX_LENGTH} characters or less`,
    STATE_REQUIRED: "State is required",
    STATE_LENGTH: `State must be a ${STATE_LENGTH}-letter code`,
    COUNTRY_REQUIRED: "Country is required",
    COUNTRY_LENGTH: `Country must be a ${COUNTRY_LENGTH}-letter code`,
    ZIP_CODE_REQUIRED: "Zip Code is required",
    ZIP_CODE_FORMAT: "Zip Code must be in format XXXXX or XXXXX-XXXX"
  }
};

// Permission checking interfaces
export interface DDCPermissionCheck {
  hasInternalAccess: boolean;
  hasDDCMembership: boolean;
  canCreateAccount: boolean;
}

// Default form data for Create Account modal
export const DEFAULT_CREATE_ACCOUNT_FORM: CreateAccountFormData = {
  companyName: "",
  accountType: "CLIENT",
  verticalType: "AUTOMOTIVE_FRANCHISE_DEALERSHIP",
  address1: "",
  address2: "",
  city: "",
  state: "",
  country: "USA",
  zipCode: ""
};

export interface CreateAccountResponse {
  id: string;
}

export const ACCOUNT_TYPE_OPTIONS: {
  value: accountTypes;
  label: string;
}[] = [
  { value: "CLIENT", label: "Client" },
  { value: "DEMO", label: "Demo" },
  { value: "TEST", label: "Test" }
];

export const VERTICAL_TYPE_OPTIONS: { value: verticalTypes; label: string }[] =
  [
    { value: "AUTOMOTIVE_FRANCHISE_DEALERSHIP", label: "Franchise" },
    { value: "AUTOMOTIVE_DEALERSHIP_GROUP", label: "Group" },
    {
      value: "AUTOMOTIVE_INDEPENDENT_DEALERSHIP",
      label: "Independent"
    }
  ];
